import { useContext } from 'react'

import { ThemeManagerContext } from '@presentation/contexts'

export const useTheme = () => useContext(ThemeManagerContext)
